// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q2/2023byd_drbs/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const saveinfo = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};
const saveuser = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save_user`, qsData);
};
const updateuser = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}update_user`, qsData);
};
const checkInfo = (unionid: string, inway: number) => {//用户的标志和作品阶段的标志
  return http.get(`${urlPrefix}isexit&unionid=${unionid}&inway=${inway}`);
};
const checkUser = (unionid: string) => {
  return http.get(`${urlPrefix}check-first&unionid=${unionid}`);
};
const checkVoteNum = (unionid: string) => {
  return http.get(`${urlPrefix}check-vote-num&unionid=${unionid}`);
};
const getDetail = (unionid: string, inway: string) => {
  return http.get(`${urlPrefix}get_detail&unionid=${unionid}&inway=${inway}`);
};
const getuserInfo = (unionid: string, inway: string) => {//查询作品的详细信息
  return http.get(`${urlPrefix}detail&unionid=${unionid}&inway=${inway}`);
};
const intoLevelCheck = (inway: string, unionid: string ) => {//查询当前用户是否晋级
  return http.get(`${urlPrefix}into_level_check&inway=${inway}&userId=${unionid}`);
};
const getList = (page: number, keyword?: string, inway?: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search: keyword,
      inway: inway,
    },
  });
};
const getAllData = (inway: number) => {
  return http.get(`${urlPrefix}get_all_data&inway=${inway}`);
};
const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};
const wxSdkInfoZHBF = (jssdkurl: any) => {
  return http.get('/vote/public/controller.php?enews=jssdk&token=cq_byd', {
    params: { ...jssdkurl },
  });
}

export {
  getBaseInfo,
  saveinfo,
  checkInfo,
  checkUser,
  saveuser,
  updateuser,
  getDetail,
  getuserInfo,
  getList,
  getAllData,
  getRule,
  checkVoteNum,
  wxSdkInfoZHBF, 
  intoLevelCheck
};
